import styled from 'styled-components';

export const StyledBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(33, 43, 54, 0.45);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 10vh 16px 16px;
  z-index: 100;
`;

export const StyledModal = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.18);
  width: 100%;
  max-width: 520px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 20px;
  border-bottom: 1px solid #e1e3e5;
  flex-shrink: 0;
  .close {
    width: 28px;
    height: 28px;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
    border-radius: 6px;
    display: grid;
    place-items: center;
    color: #616161;
  }
  .close:hover {
    background: rgba(0, 0, 0, 0.05);
    color: #303030;
  }
`;

export const StyledBody = styled.div`
  padding: 20px;
  overflow-y: auto;
  flex: 1;
`;

export const StyledFooter = styled.div<{ $hasSupport: boolean }>`
  padding: 12px 16px;
  border-top: 1px solid #e1e3e5;
  background: #fafbfb;
  display: flex;
  justify-content: ${(p) => (p.$hasSupport ? 'space-between' : 'flex-end')};
  gap: 8px;
  flex-shrink: 0;
`;

export const StyledSteps = styled.ol`
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0 0 12px;
  li {
    font-size: 13px;
    line-height: 1.55;
    color: #303030;
  }
`;

export const StyledUrlField = styled.div`
  display: flex;
  gap: 8px;
  align-items: stretch;
  margin: 12px 0;
  input {
    flex: 1;
    padding: 7px 12px;
    border: 1px solid #c9cccf;
    border-radius: 8px;
    background: #fafbfb;
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-size: 12.5px;
    color: #303030;
    min-width: 0;
  }
`;

export const StyledNotice = styled.div`
  padding: 10px 12px;
  background: #ebf9fc;
  border: 1px solid #98c6d3;
  border-radius: 8px;
  font-size: 12.5px;
  color: #00527c;
  margin: 12px 0;
  line-height: 1.5;
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

export const StyledOfficialGuide = styled.div`
  font-size: 13px;
  color: #303030;
  margin: 12px 0 0;
  a {
    color: #005bd3;
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
`;
